import { useSelector } from 'react-redux';
import { closeAppIssueReportDrawer } from '@/redux/actions/uiActions/drawerActions';
import { useArgSelector } from '@/redux/curriedSelectors/curriedSelectors';
import selectors from '@/redux/selectors/selectors';
import appScreenSelectors from '../redux/selectors/appScreenSelectors';
import FixerReportModal from '../pages/appFixer/FixerReportModal.jsx';

const AppEditorIssueReportModal = () => {
  const appId = useArgSelector(selectors.param, 'appId');
  const open = useSelector((state) => state.ui.appIssueReportDrawer?.open);
  const actionId = useSelector((state) => appScreenSelectors.activeAppAction(state)?.id);

  if (!open) {
    return null;
  }

  return <FixerReportModal key={appId} show={true} initialAppId={appId} initialActionId={actionId} onHide={closeAppIssueReportDrawer} />;
};

export default AppEditorIssueReportModal;
